import React, { useEffect, useState } from "react";
import FormField from "../../../../components/common/FormField";
import {
  CREATE_CREDIT_INVOICE_FORM_ELEMENTS,
  invoiceValidateForm,
} from "../invoiceUntils";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { Grid } from "@mui/material";
import { set } from "lodash";
interface InvoiceFormProps {
  formData: any;
  setFormData: any;
  isFormReadyOnly: any;
  isNewInvoice?: boolean; // Optional prop to indicate if it's a new invoice
  invoiceType?: any;
}
const InvoiceForm: React.FC<InvoiceFormProps> = (props) => {
  const { formData, setFormData, isFormReadyOnly, isNewInvoice, invoiceType } =
    props;

  const [errors, setErrors] = useState<any>({});
  const { userProfile } = useSelector((state: any) => state?.user);
  const { leadDetails } = useSelector((state: any) => state.lead);
  const { customerInvoices } = useSelector((state: any) => state.invoice);
  const { editClientOriginalData } = useSelector(
    (state: any) => state.adminClients
  );

  const [isProfessionalSection, setIsProfessionalSection] = useState(
    userProfile?.features?.includes("Professional Financial") || false // Safe fallback
  );

  useEffect(() => {
    setIsProfessionalSection(
      userProfile?.features?.includes("Professional Financial") || false
    ); // Sync profile changes
  }, [userProfile]);

  const DYNAMIC_REFERAL_OPTIONS = customerInvoices?.length
        ? customerInvoices.map((item: any) => ({
            id: item.invoice_number ?? item.invoice_number,
            name: item.invoice_number ?? item.invoice_number,
            tooltip: item.description || item.tooltip || "", // << ADD TOOLTIP
          }))
        : [];

  const FORM_FIELDS_UPDATED =  CREATE_CREDIT_INVOICE_FORM_ELEMENTS.map((field) => {
    if (field.id === "reference_invoices") {
      return { ...field, options: DYNAMIC_REFERAL_OPTIONS };
    }
    return field;
  });

  const onChangeAction = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = event.target;
   if(id === 'reference_invoices'){
    const selectedRefs = Array?.isArray(value) ? value : [value];

     const selectedInvoices = customerInvoices.filter((inv: any) =>
      selectedRefs.includes(inv.invoice_number)
    );

    // convert selected invoices into credit items
    // If the invoice has items, use them; otherwise create a single item
    const creditItems = selectedInvoices.flatMap((inv: any) => {
      if (inv.items && Array.isArray(inv.items) && inv.items.length > 0) {
        // Use existing items from the invoice
        return inv.items.map((item: any) => {
          const itemPrice = item.price || (item.rate * item.quantity) || 0;
          const itemVatRate = item.vat_rate || inv.vat_rate || Number(editClientOriginalData?.vat_percent || 0);
          const itemVatValue = ((itemPrice * itemVatRate) / 100).toFixed(2);
          const itemTotal = (parseFloat(itemPrice) + parseFloat(itemVatValue)).toFixed(2);
          
          return {
            quantity: item.quantity || 1,
            description: item.description || `${inv.invoice_number} - Credit Note`,
            rate: item.rate || item.unit_price || 0,
            price: itemPrice,
            vat_rate: itemVatRate,
            vat_value: itemVatValue,
            total: itemTotal,
          };
        });
      } else {
        // Create a single item for the entire invoice
        const invoicePrice = inv.net_amount || inv.total_amount || 0;
        const invoiceVatRate = inv.vat_rate || Number(editClientOriginalData?.vat_percent || 0);
        const invoiceVatValue = ((invoicePrice * invoiceVatRate) / 100).toFixed(2);
        const invoiceTotal = (parseFloat(invoicePrice) + parseFloat(invoiceVatValue)).toFixed(2);
        
        return [{
          quantity: 1,
          description: `${inv.invoice_number} - Credit Note`,
          rate: invoicePrice,
          price: invoicePrice,
          vat_rate: invoiceVatRate,
          vat_value: invoiceVatValue,
          total: invoiceTotal,
        }];
      }
    });

    const itemsTotal = creditItems.reduce(
      (sum: number, item: any) => sum + parseFloat(item.total || 0),
      0
    );
    setFormData((prev: any) => ({
      ...prev,
      reference_invoices: selectedRefs,
      items: creditItems,
      net: itemsTotal
    }) );
    return; // Exit early after handling reference_invoices
   }
    // Handle nested address fields differently
    if (id.startsWith("address.")) {
      const field = id.split(".")[1]; // e.g. 'street', 'town', etc.
      setFormData((prev: any) => ({
        ...prev,
        address: {
          ...prev.address,
          [field]: value,
        },
      }));
      // Validate nested address changes
      const updatedData = {
        ...formData,
        address: {
          ...formData.address,
          [field]: value,
        },
      };
      const validationResults = invoiceValidateForm(updatedData);
      setErrors(validationResults.localError);
    } else if (id === "invoice_type") {
      const updatedFormData = {
        ...formData,
        invoice_type: invoiceType,
      };
      setFormData(updatedFormData);

      // Clear address fields if invoice_type is 'deposit' or 'final'
    } else {
      const updatedFormData = {
        ...formData,
        [id]: value,
      };
      setFormData(updatedFormData);
      // Validate after updating form data
      const validationResults = invoiceValidateForm(updatedFormData);
      setErrors(validationResults.localError);
    }
  };

  return (
    <Grid
      container
      spacing={0.5}
      sx={{
        mt: 1,
        backgroundColor: "#E5F4F1",
        border: "1px solid #CFCFCF",
        borderRadius: "5px",
        padding: "10px 6px",
      }}
    >
      {FORM_FIELDS_UPDATED?.map((field, i) => {
        if (field.id === "address") {
          if (
            isNewInvoice &&
            formData?.invoice_type !== "deposit" &&
            formData?.invoice_type !== "final"
          ) {
            // Editable address fields for new invoice
            const addressFields = [
              {
                id: "street",
                label: "Street",
                md: 6,
                type: "text",
                isFormReadyOnly: true,
              },
              // { id: "", label: "", type: "title", md: 0.5 },
              {
                id: "town",
                label: "Town",
                md: 3,
                type: "text",
                isFormReadyOnly: true,
              },
              {
                id: "county",
                label: "County",
                md: 3,
                type: "text",
                isFormReadyOnly: true,
              },
              // { id: "", label: "", type: "title", md: 0.5 },
              {
                id: "country",
                label: "Country",
                md: 3,
                type: "text",
                isFormReadyOnly: true,
              },
              // { id: "", label: "", type: "title", md: 0.5 },
              {
                id: "postcode",
                label: "Postcode",
                md: 3,
                type: "text",
                isFormReadyOnly: true,
              },
            ];

            return addressFields.map(({ id, label, md, type }) => (
              <FormField
                key={id}
                id={`address.${id}`} // Dot notation for nested field
                label={label}
                type={type}
                value={formData?.address?.[id] || ""}
                onChange={onChangeAction}
                error={!!errors?.address?.[id]}
                disabled={isFormReadyOnly}
                isNonMarginTop
                md={md}
                inSingleGridForm={true}
                InputProps={{
                  ...(field?.inputProps || {}),
                  // disabled: isFormReadyOnly || field?.editReadOnly,
                  sx: type === "text" ? { height: "36px" } : { padding: "4px" },
                }}
              />
            ));
          } else {
            // Read-only full address string for existing invoice
            const addr = formData?.address || {};
            const formattedAddress = `${addr.street || ""}${
              addr.street ? ", " : ""
            }${addr.town || ""}${addr.town ? ", " : ""}${addr.county || ""}${
              addr.county ? ", " : ""
            }${addr.country || ""}${addr.country ? ", " : ""}${
              addr.postcode || ""
            }`;

            return (
              <FormField
                key={`address-readonly-${i}`}
                id="address"
                label={field.label}
                value={formattedAddress}
                type="text"
                disabled
                multiline
                isNonMarginTop
                md={field.md}
                inSingleGridForm={true}
                InputProps={{
                  sx: { padding: "4px" },
                }}
                error={false}
              />
            );
          }
        }
        // Default handling for all other fields
        return (
          <FormField
            key={i}
            onPaste={(e: any) => e.preventDefault()}
            onKeyDown={(event: any) => {
              if (
                event.keyCode === 8 ||
                event.keyCode === 9 ||
                event.keyCode === 37 ||
                event.keyCode === 38 ||
                event.keyCode === 39 ||
                event.keyCode === 40 ||
                event.keyCode === 18 ||
                event.keyCode === 17 ||
                event.ctrlKey
              )
                return;

              if (
                field?.patternAllowed &&
                !field?.patternAllowed.test(event.key)
              ) {
                event.preventDefault();
              } else if (
                field?.patternAllowed &&
                !field?.patternAllowed.test(event.target.value + event.key)
              ) {
                event.preventDefault();
              }
            }}
            {...{
              ...field,

              value:
                field.id === "invoice_type" &&
                isProfessionalSection &&
                isNewInvoice
                  ? invoiceType || ""
                  : field?.id === "address"
                  ? `${formData?.street || ""} ${formData?.town || ""} ${
                      formData?.county || ""
                    } ${formData?.country || ""} ${formData?.postcode || ""}` // Concatenate street and town
                  : field?.id === "created_at"
                  ? dayjs(formData && formData[field?.id]).format(
                      userProfile?.dateFormat
                        ? userProfile?.dateFormat
                        : "DD/MM/YYYY"
                    )
                  : formData
                  ? formData[field?.id]
                  : "",

              variant: "outlined",
              onChange: onChangeAction,
              // onBlur: onBlurAction,
              isNonMarginTop: true,
              inSingleGridForm: true,
              // disableBackground: "#eeecef",
              multiline: true,
              disabled:
                isFormReadyOnly ||
                field?.editReadOnly ||
                (formData?.invoice_type === "deposit" &&
                  leadDetails?.lead?.status === "JOB"),
              InputProps: {
                ...(field?.inputProps && field?.inputProps),
                ...{ disabled: isFormReadyOnly || field?.editReadOnly },
                sx:
                  field?.type === "text" || field?.type === "password"
                    ? { height: "36px" }
                    : { padding: "4px" },
              },

              error: !!errors?.[field.id],
              // helperText: errors?.[field.id] || '',
            }}
          />
        );
      })}
    </Grid>
  );
};

export default InvoiceForm;
